<app-dynamic-component
  *ngFor="let panel of items; last as isLast"
  [data]="panel"
  id="{{ panel.anchor?.value }}"
  #panels
  [class.last]='markLast && isLast'
></app-dynamic-component>
